module.exports = __webpack_public_path__ + "img/1526323987.39942972.jpg";